/**
 * Component to render scene info to the user
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import renderHTML from 'react-render-html';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";

// import utilities
import richContentUtils from '../../../global/utils/richContentUtils';
import videoUtils from "../../../global/utils/videoUtils.js";

// import module components

// import scene css modules
import sceneStyles from '../sceneModuleStyles.css';

class SceneVideo extends Base {
  constructor(props) {
    super(props);
  }


  shouldComponentUpdate(nextProps) {
    /**
     * ISSUE: video component re-renders a bunch of times on slow loads, flickering the screen
     *  this is happening because its complicated and slow to render, NOT because it's rendering too many times
     * it re-renders on any prop change. however, we can force it to only render under certain conditions
     * in practice, i THINK only the last one necessary (fetching one). but something like this can cause unintended behavior so it's better to be careful.
     * https://reactjs.org/docs/react-component.html#shouldcomponentupdate
     *
     * TESTING: comment out this entire method to test without it
    */

    const update =
    nextProps.courseId !== this.props.courseId
    || nextProps.contentModuleId !== this.props.contentModuleId
    || nextProps.scene._id !== this.props.scene._id
    ;
    console.log("Should we update the VideoPlayer component?", update);
    return update;

  }

  render() {
    const {
      autoPlay
      , courseId
      , handleReady
      , location
      , match
      , openFollowups
      , scene
      , contentModuleId
      , viewAs
    } = this.props;

    const playlist = scene ? videoUtils.returnPlaylist(scene.videoPath, scene.posterPath, scene.tracks) : [];
    let videoClass = classNames(
      '-video'
    )

    return (
      <div className="scene-wrapper">
        <div className="-scene-video-wrapper">
          <div className={videoClass}>
            { viewAs === 'user' ?
              <VideoPlayer
                isAutoPlay={autoPlay}
                onComplete={openFollowups}
                handleReady={handleReady}
                playerId={scene._id + '-big-video'}
                playlist={playlist}
                tracking={{
                  _course: courseId
                  , _contentModule: contentModuleId
                  , _scene: scene._id
                  , _node: match.params.nodeId
                  , description: courseId ? 'user-node' : 'user-node-agenda'
                }}
              />
              :
              <VideoPlayer
                isAutoPlay={true}
                onComplete={this._onVideoComplete}
                playerId={scene._id}
                playlist={playlist}
              />
            }
          </div>
        </div>
      </div>
    )
  }
}

SceneVideo.propTypes = {
  autoPlay: PropTypes.bool
  , courseId: PropTypes.string
  , handleReady: PropTypes.func.isRequired
  , openFollowups: PropTypes.func.isRequired
  , scene: PropTypes.object.isRequired
  , contentModuleId: PropTypes.string
  , viewAs: PropTypes.string
}

SceneVideo.defaultProps = {
  autoPlay: true
  , courseId: null
  , contentModuleId: null
  , viewAs: 'user'
}

export default withRouter(SceneVideo);



// WEBPACK FOOTER //
// modules/scene/components/SceneVideo.js.jsx